// // Use $ instead of jQuery without replacing global $
(function ($) {
  // var $IE_image = $('img.ie-responsive');
  // objectFitImages($IE_image);

  $(window).on("load", function () {

    $(".resource-slider.ref-slider .slider-outer .video-slider .slider .item").unwrap();
    $(".resource-slider.ref-slider .slider-outer .video-slider .slider .item").unwrap();

    $(".resource-slider.ref-slider .slider-outer .tech-slider .slider .item").unwrap();
    $(".resource-slider.ref-slider .slider-outer .tech-slider .slider .item").unwrap();

    $('.resource-slider .slider-outer .video-slider .slider').slick({
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      fade: false,
      infinite: false,
      draggable: false,
      prevArrow: $('.resource-slider .video-slider .slide-nav .slide-prev'),
      nextArrow: $('.resource-slider .video-slider .slide-nav .slide-next'),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            draggable: true
          }
        }
      ]
    });

    $('.resource-slider .slider-outer .tech-slider .slider').slick({
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      fade: false,
      infinite: false,
      draggable: false,
      prevArrow: $('.resource-slider .tech-slider .slide-nav .slide-prev'),
      nextArrow: $('.resource-slider .tech-slider .slide-nav .slide-next'),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            draggable: true
          }
        }
      ]
    });

    if ($('.resource-slider .slider-outer .slider.slick-initialized').length > 0) {
      $('.resource-slider').css({'opacity': 1});
    }
  });

  $(document).ready(function () {
    // $(".resource-slider .slider-outer .video-slider .slider .item .content").matchHeight();
    // $(".resource-slider .slider-outer .tech-slider .slider .item .content").matchHeight();
    $(".resource-slider .slider-outer .video-slider .slider .item .content h5, .resource-slider .slider-outer .tech-slider .slider .item .content h5").matchHeight();
    // limit_lines('.resource-slider .slider-outer .slider .item .content h5', 3);
  });

  $(window).resize(function () {
    // limit_lines('.resource-slider .slider-outer .slider .item .content h5', 3);
  });

})(jQuery);
